/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_SubtitleInputs */

const cs_dashboard_subtitle = /** @type {(inputs: Dashboard_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přehled klíčových ukazatelů za zvolené období.`)
};

const en_dashboard_subtitle = /** @type {(inputs: Dashboard_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key performance indicators for the selected period.`)
};

/**
* | output |
* | --- |
* | "Key performance indicators for the selected period." |
*
* @param {Dashboard_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_subtitle = /** @type {((inputs?: Dashboard_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_subtitle(inputs)
	return cs_dashboard_subtitle(inputs)
});